<div>
  <h3 *ngIf="pictufyData">Artworks: {{utility.numberFormat(pictufyData.artworks)}}</h3>
  <table class="fullwidth styled compact stores">
    <tr>
      <th></th>
      <th class="align-right">{{ 'Artworks' | translate }}</th>
      <th class="align-right">{{ 'Shopify-produkter' | translate }}</th>
      <th class="align-right">{{ 'Återstående' | translate }}</th>
    </tr>
    <ng-container *ngFor="let store of stores">
      <tr *ngIf="storeData[store._id]">
        <td>{{store.name}}</td>
        <td class="align-right">{{utility.numberFormat(storeData[store._id].artworks)}}</td>
        <td class="align-right">{{utility.numberFormat(storeData[store._id].shopifyProducts)}}</td>
        <td class="align-right">{{utility.numberFormat(storeData[store._id].artworks -
          storeData[store._id].shopifyProducts)}}</td>
      </tr>
    </ng-container>


  </table>
<br/>
<br/>
<br/>
</div>
